export default __webpack_public_path__ + "images/Sushi.98e588.jpg";